<section>
  <button
    [attr.aria-label]="ariaLabel"
    [attr.aria-labelledby]="ariaLabelledby"
    [attr.aria-describedby]="ariaDescribedby"
    [attr.aria-disabled]="ariaDisabled"
    [attr.role]="role"
    class="button-primary"
    mat-raised-button
    [type]="type"
    [disabled]="this.disabled || this.loading">
    <span class="d-flex align-items-center justify-content-center">
      <mat-spinner
        [id]="'loading-button-' + id"
        *ngIf="this.loading"
        diameter="25"></mat-spinner>
    </span>
    <span>
      <ng-content
        *ngIf="!this.loading"
        id="projected-content-button"></ng-content>
    </span>
  </button>
</section>
